// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { AuthProvider } from './context/AuthContext'; // YENİ

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* AuthProvider ile tüm App component'ini sarıyoruz */}
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);